var errors = document.getElementsByClassName('form-error-message');
if(errors.length) {
    var firstError = errors[0];

    const y = firstError.getBoundingClientRect().top + window.scrollY;
    window.scroll({
        top: y - 200,
        behavior: 'smooth'
    });
}